module.exports = "<app-snow *ngIf=\"showSnow\"></app-snow>\n<router-outlet>\n    <app-spinner><app-title></app-title></app-spinner>\n</router-outlet>\n"